import React, { useState, useEffect } from "react";
import { IOffer } from "../../../../shared/store/payment/types";
import { payment } from "../PaymentOffer/PaymentOffer";
import { Loader } from "../../../../shared/ui/Loader";
import copy from "../../../../shared/assets/icons/copy.svg";
import { createMaskForCardNumber } from "../../../../shared/utils/maskForCardNum";
import { BANK__NAMES } from "../../../../shared/consts";
import styles from "./index.module.scss";
import { copyTextToClipboard } from "../../../../shared/utils/copy";
import { createPortal } from "react-dom";
interface ICopyCardDetail {
  offerData: IOffer | null;
  detailType: payment;
}

export const CopyCardDetail: React.FC<ICopyCardDetail> = ({
  offerData,
  detailType,
}) => {
  const [isNotifActive, setStatus] = useState(false);
  const copyText = (copyValue: string | number) => {
    copyTextToClipboard(String(copyValue));
    setStatus(true);
  };
  const getDetail = (key: payment["key"]) => {
    if (offerData) {
      if (key === "cardNumber") {
        return createMaskForCardNumber(offerData[key]);
      }

      if (offerData.phoneNumber && key === "phoneNumber") {
        return `${offerData[key]} (${offerData.providerName})`;
      }
      return offerData[key];
    }
  };

  useEffect(() => {
    const id = setTimeout(() => {
      setStatus(false);
    }, 1500);

    return () => {
      clearTimeout(id);
    };
  }, [isNotifActive]);

  const toast = isNotifActive
    ? createPortal(
        <div className={styles.toast}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Скопировано
        </div>,
        document.body
      )
    : null;

  return offerData && offerData[detailType.key] ? (
    <>
      {toast}
      <button
        type="button"
        className={styles.payment_card_item}
        onClick={() => copyText(offerData[detailType.key])}
      >
        <div className={styles.payment_card_text}>
          <span className={styles.payment_card_value}>{detailType.title}</span>
        </div>
        <div className={styles.payment_detail}>
          <p className={styles.payment_detail_value}>
            {getDetail(detailType.key)}
          </p>
          <div className={styles.payment_card_copy}>
            <img src={copy} alt="Скопировать" className={styles.img_copy} />
          </div>
        </div>
      </button>
    </>
  ) : (
    <></>
  );
};
